import * as React from 'react';
import { Col, Row } from '../Grid';
import { useTheme } from '../Theme/Theme';
import { Text } from '../Text/Text';
import { style } from './style';
import { classes } from '../../helpers';
export const Progress = (props) => {
    const theme = useTheme();
    const css = style(theme, props);
    if (props.type === 'circle') {
        const radius = 52;
        const circumference = radius * 2 * Math.PI;
        const offset = circumference - (props.percent / 100) * circumference;
        return (React.createElement("div", { style: { position: 'relative', display: 'inline-block' } },
            React.createElement("svg", { width: "120", height: "120" },
                React.createElement("circle", { className: classes(css.circle, 'sha-el-progress-circle'), style: { strokeDashoffset: offset, strokeDasharray: `${circumference} ${circumference}` }, stroke: theme[props.status], strokeWidth: "10px", fill: "transparent", r: radius, cx: "60", cy: "60" })),
            React.createElement(Text, { style: { position: 'absolute', top: '45%', textAlign: 'center', width: '100%' } }, props.label)));
    }
    return (React.createElement(Row, null,
        React.createElement(Col, { flex: "1 0 auto" },
            React.createElement("div", { className: classes(css.container, 'sha-el-progress') },
                React.createElement("div", { style: { width: props.percent + '%' }, className: classes(css.line, 'sha-el-progress-line') }))),
        props.label && React.createElement(Col, { flex: "0 1 auto" }, props.label)));
};
Progress.defaultProps = {
    type: 'line',
    status: 'primary',
};
//# sourceMappingURL=Progress.js.map